export default "__VITE_ASSET__80861729__"